import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../features/auth/useAuth'
import { usePushDeepLink } from '../features/push/usePushDeepLink'
import { settlePendingCompletions } from '../offline/session'
import { registerFlushTriggers } from '../offline/sync'

/** The root route: app-wide effects that need the router, then the matched route. */
export function RootLayout() {
  const { auth } = useAuth()

  // Notification deep links. Gated on auth deliberately: until there is a session to deep
  // link *into*, the payload stays queued rather than being spent on the login
  // screen. See the hook.
  usePushDeepLink(Boolean(auth))

  useEffect(() => {
    // §12.1: app open, `online`, regained visibility — all registered once, here.
    const unregister = registerFlushTriggers()
    void settlePendingCompletions()
    return unregister
  }, [])

  return <Outlet />
}
